import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { forkJoin, Observable, of } from 'rxjs';
import { Currency } from '../currency';
import { HttpService } from '../service/http.service';
import { SalesProductType } from '../sales-product-type';
import Decimal from 'decimal.js';
import { SalesProduct } from '../sales-product';
import { ToastMessageService } from '../toast-message.service';
import { CKEDITORCONFIGMINIMAL, CKEDITORCONFIGMINIMALWITHLINK } from '../ckeditor-config';
import { ContactRequestQuotation } from '../contact-request-quotation';
import { ContactRequestService } from '../service/contact-request.service';
import { LeadQuotationService } from '../service/lead-quotation.service';
import { QuotationTemplateService } from '../quotation-template.service';
import { QuotationTemplate } from '../quotation-template';
import { QuotationTemplateWithDetail } from '../quotation-template-with-detail';
import { QuotationTemplateProduct } from '../quotation-template-product';
import { ProductTypeService } from '../service/product-type.service';
import { ExchangeRateService } from '../service/exchange-rate.service';
import * as Editor from '../../libs/ckeditor';



@Component({
  selector: 'app-create-contact-request-quotation',
  templateUrl: './create-contact-request-quotation.component.html',
  styleUrls: ['./create-contact-request-quotation.component.css']
})
export class CreateContactRequestQuotationComponent implements OnInit {

  @Input("requestId")
  requestId!: number;

  productTypes: SalesProductType[] = [];
  currencies: Currency[] = [];
  productPriceInCurrency: string[] = [];
  productPriceInSecondCurrency: string[] = [];
  yearRange: string = "";
  editorConfig = CKEDITORCONFIGMINIMAL;
  descriptionEditorConfig = CKEDITORCONFIGMINIMALWITHLINK;
  displayTemplateDialog = false;
  displayTemplateCreatingDialog = false;
  productsToDelete: QuotationTemplateProduct[] = [];

  templates: QuotationTemplate[] = [];
  selectedTemplateName: string | null = null;
  templateTooltips: string[] = [];
  totalPriceInBaseCurrency = new Decimal(0);
  totalPriceInSecondCurrency: Decimal | null = null;
  totalInsuranceInBaseCurrency = new Decimal(0.00);
  totalGarantieAnnulationInBaseCurrency = new Decimal(0.00);
  totalGarantieAnnulationInSecondCurrency = new Decimal(0.00);

  TRAVEL_INSURANCE_ID = 15;
  GARANTIE_ANNULATION_ID = 7;
  GARANTIE_ANNULATION_RATE = new Decimal(0.04);
  public Editor = Editor;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService,
    public contactRequestService: ContactRequestService,
    public leadQuotationService: LeadQuotationService,
    private quotationTemplateService: QuotationTemplateService,
    private exchangeRateService: ExchangeRateService,
    private productTypeService: ProductTypeService
  ) {}

  ngOnInit(): void {
    this.yearRange = (moment().year() - 10) + ":" + (moment().year() + 4);
    this.httpService.getCurrencies().subscribe(currencies => {
      this.currencies = currencies;
    });

    this.httpService.getSalesProductTypes().subscribe(res => {
      this.productTypes = res;
      if (this.leadQuotationService.quotationForm == undefined || this.leadQuotationService.quotationForm == null) {
        this.leadQuotationService.quotationForm = this.builder.group({
          description: "",
          comment: "",
          products: this.builder.array([]),
          baseCurrency: new Currency(1, "Euro", "EUR", "€"),
          secondCurrency: null,
          quotationDate: moment().toDate(),
          dueDate: null,
          deposit: new Decimal(250.00),
          priceIncludes: "",
          priceNotIncludes: ""
        });
        this.insertItem(0);
      } else {
        //update total if cloning quotation
        this.calculateProductPricesInCurrency();
        this.updateTotalPriceInCurrency();
      }
    });
  }

  get quotationDate(): moment.Moment{
    return moment(this.leadQuotationService.quotationForm!.value.quotationDate).utc(true);
  }

  mouseover(i: number) {
    let array = this.leadQuotationService.quotationForm!.get("products") as FormArray;
    array.controls[i].get("activeMenu")!.setValue(true);
  }
  mouseout(i: number) {
    let array = this.leadQuotationService.quotationForm!.get("products") as FormArray;
    array.controls[i].get("activeMenu")!.setValue(false);
  }

  moveItem(array: any[], i: number, delta: number) {
    let newIndex = i + delta;
    if (newIndex < 0 || newIndex >= array.length) {
      return;
    }
    let indexes = [i, newIndex].sort();
    array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]);
  }

  moveUp(i: number) {
    let itemArray = this.leadQuotationService.quotationForm!.get("products") as FormArray;
    this.moveItem(itemArray.controls, i, -1);
  }

  moveDown(i: number) {
    let itemArray = this.leadQuotationService.quotationForm!.get("products") as FormArray;
    this.moveItem(itemArray.controls, i, 1);
  }

  insertAt(array: AbstractControl[], index: number, element: FormGroup) {
    array.splice(index, 0, element);
  }

  insertItem(i: number) {
    let itemArray = this.leadQuotationService.quotationForm!.get("products") as FormArray;
    this.insertAt(itemArray.controls, i + 1, this.builder.group({
      type: this.productTypes[0],
      description: "",
      amount: [new Decimal(0.00), Validators.pattern(/^-?[.\d]+$/)],
      currency: new Currency(1, "Euro", "EUR", "€"),
      activeMenu: false,
      id: null
    }));
  }

  removeItem(i: number) {
    let itemArray = this.leadQuotationService.quotationForm!.get("products") as FormArray;
    if (itemArray.value[i].id != null && itemArray.value[i].id != undefined) {
      this.productsToDelete.push(itemArray.value[i]);
    }
    itemArray.controls.splice(i, 1);
    this.calculateProductPricesInCurrency();
    this.updateTotalPriceInCurrency();
  }

  pressTabOnCurrencyDropdown(i: number) {
    let itemArray = this.leadQuotationService.quotationForm!.get("products") as FormArray;
    if (i == itemArray.controls.length - 1) {
      this.insertItem(i);
    }
  }

  createQuotation() {
    let quotation = this.getQuotationFromForm();
    this.httpService.postContactRequestQuotation(quotation, this.requestId).subscribe(() => {
      console.log("success");
      this.toastService.addSuccess("Success", "Success");
    }, error => this.toastService.addError("Error", error.message));
  }

  getProductList() {
    let products = [];
    let productFormArray = this.leadQuotationService.quotationForm!.get("products") as FormArray;
    for (let product of productFormArray.controls) {
      products.push(new SalesProduct(
        product.get("type")!.value,
        product.get("description")!.value,
        new Decimal(product.get("amount")!.value),
        product.get("currency")!.value,
        product.get("id")!.value
      ));
    }
    return products;
  }

  setProductList() {
    let products = [];
    console.log(this.leadQuotationService.quotationForm!.get("products"));
    let productFormArray = this.leadQuotationService.quotationForm!.get("products") as FormArray;
    for (let productForm of productFormArray.controls) {
      products.push(new SalesProduct(
        productForm.get("type")!.value,
        productForm.get("description")!.value,
        new Decimal(productForm.get("amount")!.value),
        productForm.get("currency")!.value,
        productForm.get("id")!.value
      ));
    }
    return products;
  }

  activateTemplateSavingDialog() {
    this.displayTemplateCreatingDialog = true;
  }

  saveQuotationAsTemplate() {
    if (!(this.contactRequestService.contactRequest!.school && this.contactRequestService.contactRequest!.language && this.selectedTemplateName)) {
      this.toastService.addError("Error", "School, Template name or Language is missing");
      return;
    }
    this.httpService.checkIfTemplateNameExists(this.selectedTemplateName, this.contactRequestService.contactRequest!.school.id!, 
      this.contactRequestService.contactRequest!.language.id).subscribe(res => {
      if (res == true) {
        this.toastService.addError("Error", "This template name is already used. Please select another name.");
        return;
      } else {
        this.quotationTemplateService.saveContactRequestQuotationAsTemplate(this.getQuotationFromForm(), this.contactRequestService.contactRequest!.school, 
        this.contactRequestService.contactRequest!.language, this.selectedTemplateName!).subscribe(() => {
          this.toastService.addSuccess("Success", "Template saved");
        }, error => this.toastService.addError("Error", error.message));
      }
    }, error => this.toastService.addError("Error", error.message));
  }

  getQuotationFromForm() {
    return new ContactRequestQuotation(
      this.leadQuotationService.quotationForm!.value.description,
      this.leadQuotationService.quotationForm!.value.comment,
      this.setProductList(),
      this.leadQuotationService.quotationForm!.value.baseCurrency,
      this.leadQuotationService.quotationForm!.value.secondCurrency,
      this.leadQuotationService.quotationForm!.value.quotationDate == null ? null : moment(this.leadQuotationService.quotationForm!.value.quotationDate).utc(true),
      this.leadQuotationService.quotationForm!.value.dueDate == null ? null : moment(this.leadQuotationService.quotationForm!.value.dueDate).utc(true),
      this.leadQuotationService.quotationForm!.value.deposit,
      this.leadQuotationService.quotationForm!.value.priceIncludes,
      this.leadQuotationService.quotationForm!.value.priceNotIncludes);
  }

  getQuotationTemplates() {
    // this.selectedTemplate = null;
    if (this.contactRequestService.contactRequest!.school && this.contactRequestService.contactRequest!.language) {
      this.httpService.getTemplatesBySchoolAndLanguage(this.contactRequestService.contactRequest!.school.id!, this.contactRequestService.contactRequest!.language.id).subscribe(res => {
        this.templates = res;
        this.displayTemplateDialog = true;

        this.templateTooltips = [];
        for (let template of this.templates) {
          let tooltipMessage = "";
          for (let product of template.products) {
            tooltipMessage = tooltipMessage + product.productType.name + " " + product.amount + " " + product.currency.symbol + "\n";
          }
          this.templateTooltips.push(tooltipMessage);
        }
      });
    } 
  }

  setFormValuesFromTemplate(selectedTemplate: QuotationTemplate) {
    this.leadQuotationService.selectedQuotationTemplate = selectedTemplate;
    this.productsToDelete = [];

    this.leadQuotationService.quotationForm!.get("description")!.setValue(this.leadQuotationService.selectedQuotationTemplate.description);
    this.leadQuotationService.quotationForm!.get("comment")!.setValue(this.leadQuotationService.selectedQuotationTemplate.comment);
    this.leadQuotationService.quotationForm!.get("products")!.reset();
    this.clearFormArray(this.leadQuotationService.quotationForm!.get("products") as FormArray);
    this.leadQuotationService.quotationForm!.get("baseCurrency")!.setValue(this.leadQuotationService.selectedQuotationTemplate.baseCurrency);
    this.leadQuotationService.quotationForm!.get("secondCurrency")!.setValue(this.leadQuotationService.selectedQuotationTemplate.secondCurrency);
    this.leadQuotationService.quotationForm!.get("quotationDate")!.setValue(moment().toDate());
    this.leadQuotationService.quotationForm!.get("dueDate")!.setValue(null);
    this.leadQuotationService.quotationForm!.get("priceIncludes")!.setValue(this.leadQuotationService.selectedQuotationTemplate.priceIncludes);
    this.leadQuotationService.quotationForm!.get("priceNotIncludes")!.setValue(this.leadQuotationService.selectedQuotationTemplate.priceNotIncludes);
    let itemArray = this.leadQuotationService.quotationForm!.get("products") as FormArray;
    for (let product of this.leadQuotationService.selectedQuotationTemplate.products) {
      let newFormgroup = this.builder.group({
        type: product.productType,
        description: product.description,
        amount: [new Decimal(product.amount), Validators.pattern(/^-?[.\d]+$/)],
        currency: product.currency,
        activeMenu: false,
        id: product.id
      });
      this.setAmountFormatChecker(newFormgroup.get("amount")!);
      itemArray.push(newFormgroup);
    }
    this.displayTemplateDialog = false;
    this.calculateProductPricesInCurrency();
    this.updateTotalPriceInCurrency();
  }

  updateSelectedQuotationTemplate() {
    if (this.leadQuotationService.quotationForm!.invalid) {
      this.toastService.addError("Error", "Form is not complete");
      return;
    }
    this.leadQuotationService.selectedQuotationTemplate.description = this.leadQuotationService.quotationForm!.value.description;
    this.leadQuotationService.selectedQuotationTemplate.comment = this.leadQuotationService.quotationForm!.value.comment;
    this.leadQuotationService.selectedQuotationTemplate.products = this.getProductList();
    this.leadQuotationService.selectedQuotationTemplate.baseCurrency = this.leadQuotationService.quotationForm!.value.baseCurrency;
    this.leadQuotationService.selectedQuotationTemplate.secondCurrency = this.leadQuotationService.quotationForm!.value.secondCurrency;
    this.leadQuotationService.selectedQuotationTemplate.priceIncludes = this.leadQuotationService.quotationForm!.value.priceIncludes;
    this.leadQuotationService.selectedQuotationTemplate.priceNotIncludes = this.leadQuotationService.quotationForm!.value.priceNotIncludes;
    let templateWithDetail = new QuotationTemplateWithDetail(
      this.leadQuotationService.selectedQuotationTemplate, this.productsToDelete
    );

    this.httpService.putQuotationTemplate(templateWithDetail).subscribe(res => {
      this.toastService.addSuccess("Success", "Template updated");
      this.productsToDelete = [];
    }, error => this.toastService.addError("Error", error.message));
  }

  clearFormArray(formArray: FormArray) {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }

  onAmountBlur(i: number) {
    this.updateProductPriceInCurrency(i);
    this.updateTotalPriceInCurrency();
  }

  baseCurrencyUpdate() {
    this.calculateProductPricesInCurrency();
    this.updateTotalPriceInCurrency();
  }

  secondCurrencyUpdate() {
    this.calculateProductPricesInCurrency();
    this.updateTotalPriceInCurrency();
  }

  onProductCurrencyUpdate() {
    this.calculateProductPricesInCurrency();
    this.updateTotalPriceInCurrency();
  }

  onProductTypeUpdate(selectedProductType: SalesProductType, index: number) {
    if(this.contactRequestService.contactRequest!.language){
      this.productTypeService.setDefaultProductTypeDescription(selectedProductType, index, this.leadQuotationService.quotationForm!, 
        this.contactRequestService.contactRequest!.language.id);
    }
    this.calculateProductPricesInCurrency();
    this.updateTotalPriceInCurrency();
  }

  updateProductPriceInCurrency(index: number) {
    let productFormArray = this.leadQuotationService.quotationForm!.get("products") as FormArray;
    let product = productFormArray.controls[index];
    this.exchangeRateService.calculatePriceInCurrency(new Decimal(product.get("amount")!.value), product.get("currency")!.value,
      this.leadQuotationService.quotationForm!.get("baseCurrency")!.value, this.leadQuotationService.quotationForm!.get("baseCurrency")!.value, this.quotationDate).subscribe(amount => {
        this.productPriceInCurrency[index] = amount.toFixed(2);
      });
    if (this.leadQuotationService.quotationForm!.get("secondCurrency")!.value) {
      this.exchangeRateService.calculatePriceInCurrency(new Decimal(product.get("amount")!.value), product.get("currency")!.value,
        this.leadQuotationService.quotationForm!.get("secondCurrency")!.value, this.leadQuotationService.quotationForm!.get("secondCurrency")!.value, 
        this.quotationDate).subscribe(amount => {
          this.productPriceInSecondCurrency[index] = amount.toFixed(2);
        });
    }
  }

  calculateProductPricesInCurrency() {
    this.productPriceInCurrency = [];
    this.productPriceInSecondCurrency = [];
    let productFormArray = this.leadQuotationService.quotationForm!.get("products") as FormArray;
    for (let product of productFormArray.controls) {
      const index = productFormArray.controls.indexOf(product);
      this.exchangeRateService.calculatePriceInCurrency(new Decimal(product.get("amount")!.value), product.get("currency")!.value,
        this.leadQuotationService.quotationForm!.get("baseCurrency")!.value, this.leadQuotationService.quotationForm!.get("baseCurrency")!.value, this.quotationDate).subscribe(amount => {
          this.productPriceInCurrency[index] = amount.toFixed(2);
        });
      if (this.leadQuotationService.quotationForm!.get("secondCurrency")!.value) {
        this.exchangeRateService.calculatePriceInCurrency(new Decimal(product.get("amount")!.value), product.get("currency")!.value,
          this.leadQuotationService.quotationForm!.get("secondCurrency")!.value, this.leadQuotationService.quotationForm!.get("secondCurrency")!.value, this.quotationDate).subscribe(amount => {
            this.productPriceInSecondCurrency[index] = amount.toFixed(2);
          });
          console.log(this.leadQuotationService.quotationForm!.get("secondCurrency")!.value);
      }
    }
  }

  updateTotalPriceInCurrency() {
    let productFormArray = this.leadQuotationService.quotationForm!.get("products") as FormArray;
    let totalInBase = new Decimal(0.00);
    let totalCancellationAndInsuranceInBase = new Decimal(0.00);
    let totalCancellationAndInsuranceInSecond = new Decimal(0.00);
    let priceInBaseObs = [];
    let priceInSecondObs = [];
    let cancellationOrInsuranceObs = [];
    let cancellationOrInsuranceInSecondObs = [];
    let hasSecondCurrency = false;
    if (this.leadQuotationService.quotationForm!.value.secondCurrency) {
      hasSecondCurrency = true;
    }
    for (let productForm of productFormArray.controls) {
      let newPrice = this.exchangeRateService.calculatePriceInCurrency(new Decimal(productForm.value.amount), productForm.value.currency, this.leadQuotationService.quotationForm!.value.baseCurrency,
       this.leadQuotationService.quotationForm!.value.baseCurrency, 
      this.quotationDate);
      priceInBaseObs.push(newPrice);
      if (productForm.value.type.id == this.TRAVEL_INSURANCE_ID || productForm.value.type.id == this.GARANTIE_ANNULATION_ID) {
        cancellationOrInsuranceObs.push(newPrice);
      }
    }
    if (cancellationOrInsuranceObs.length == 0) {
      cancellationOrInsuranceObs.push(of(new Decimal(0)));
    }
    let totalInBaseObs = forkJoin(priceInBaseObs);
    let cancellationObs = forkJoin(cancellationOrInsuranceObs);
    forkJoin([totalInBaseObs, cancellationObs]).subscribe(([totalPrices, cancellationAndInsurancePrices]) => {
      for (let price of totalPrices) {
        totalInBase = totalInBase.plus(price);
      }
      this.totalPriceInBaseCurrency = totalInBase;
      for (let price of cancellationAndInsurancePrices) {
        totalCancellationAndInsuranceInBase = totalCancellationAndInsuranceInBase.plus(price);
      }
      let garantieInBaseNet = totalInBase.minus(totalCancellationAndInsuranceInBase).times(this.GARANTIE_ANNULATION_RATE);
      this.totalGarantieAnnulationInBaseCurrency = garantieInBaseNet;
    });

    if (hasSecondCurrency) {
      let totalInSecond = new Decimal(0.00);
      this.totalPriceInSecondCurrency = totalInSecond;
      for (let productForm of productFormArray.controls) {
        let newPrice = this.exchangeRateService.calculatePriceInCurrency(new Decimal(productForm.value.amount), productForm.value.currency, 
        this.leadQuotationService.quotationForm!.value.secondCurrency, this.leadQuotationService.quotationForm!.value.baseCurrency, 
        this.quotationDate);
        priceInSecondObs.push(newPrice);
        if (productForm.value.type.id == this.TRAVEL_INSURANCE_ID || productForm.value.type.id == this.GARANTIE_ANNULATION_ID) {
          cancellationOrInsuranceInSecondObs.push(newPrice);
        }
      }
      if (cancellationOrInsuranceInSecondObs.length == 0) {
        cancellationOrInsuranceInSecondObs.push(of(new Decimal(0)));
      }
      let cancellationInSecondObs = forkJoin(cancellationOrInsuranceInSecondObs);
      let totalInSecondObs = forkJoin(priceInSecondObs);
      forkJoin([totalInSecondObs, cancellationInSecondObs]).subscribe(([totalPrices, cancellationAndInsurancePrices]) => {
        for (let price of totalPrices) {
          totalInSecond = totalInSecond.plus(price);
        }
        this.totalPriceInSecondCurrency = totalInSecond;
        console.log(this.totalPriceInSecondCurrency);
        for (let price of cancellationAndInsurancePrices) {
          totalCancellationAndInsuranceInSecond = totalCancellationAndInsuranceInSecond.plus(price);
        }
        let garantieInSecondNet = totalInSecond.minus(totalCancellationAndInsuranceInSecond).times(this.GARANTIE_ANNULATION_RATE);
        this.totalGarantieAnnulationInSecondCurrency = garantieInSecondNet;
      });
    }
  }

  setAmountFormatChecker(amountControl: AbstractControl) {
    amountControl.valueChanges.subscribe(val => {
      if (!val) {
        return;
      }
      let index = val.indexOf(",");
      if (index != -1) {
        let newValue = val.substring(0, index) + "." + val.substring(index + 1, val.length);
        if (newValue.replace(/[^0-9\.]/g, "") == "") {
          amountControl.setValue("0");
        } else {
          amountControl.setValue(newValue);
        }
        amountControl.setValue(newValue.replace(/[^0-9\.]/g, ""));
      } else {
        let newValue = val.replace(/[^0-9\.]/g, "");
        if (newValue != val) {
          if (newValue == "") {
            amountControl.setValue("0");
          } else {
            amountControl.setValue(newValue);
          }
        }
      }
    });
  }

  get productFormArray(){
    let formArray = this.leadQuotationService.quotationForm!.get('products') as FormArray;
    return formArray.controls;
  }

  isHidden(index: number){
    let formArray = this.productFormArray;
    if(formArray[index].get('activeMenu')!.value){
      return false;
    }
    return true;
  }
}
